import { HTMLAttributes } from "react"
import { styled, StyleProps } from "../styles"

export const Label = styled.label<HTMLAttributes<HTMLLabelElement>>((props: StyleProps) => ({
  ...props.theme.fonts.heading,
  display: `inline-block`,
  marginBottom: props.theme.spacing(2),
}))
